export class ReimburseUtils {
  static canReimburse({ price, createdAt }: { price: number; createdAt: Date | string }): boolean {
    if (price <= 0) {
      return false;
    }

    const now = new Date();
    const testDate = new Date(createdAt);

    return testDate.getFullYear() === now.getFullYear() && testDate.getMonth() === now.getMonth();
  }
}
